import { useContext, useEffect } from 'react';
import { WebSocketContext } from '../component/WebSocketContext';
import { subscribeToWebSocket } from '../utils/utils';

export const useWebSocket = (callback, options = {}) => {
    const { onMessage, sendMessage, connected } = useContext(WebSocketContext);

    useEffect(() => {
        return subscribeToWebSocket(onMessage, callback, options);
    }, [callback, options, onMessage]);

    return { sendMessage, connected };
};
